import React, { useEffect, useState, useRef } from 'react';
import Case from './Case';
import './CaseList.css';
import HomeHero from './HomeHero';
import LiveFeed from './LiveFeed';
import CaseDetail from './CaseDetail';

const CaseList = ({ balance, onOpenBalanceModal, onAddStars }) => {
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [openCase, setOpenCase] = useState(null); // Для модалки
  const casesRef = useRef(null);

  // Курс обмена: 1 TON = 269 звезд
  const TON_TO_STARS_RATE = 269;

  const scrollToCases = () => {
    const targetElement = casesRef.current;
    
    if (!targetElement) {
      return;
    }
    
    // Плавная прокрутка с отступом
    targetElement.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start',
      inline: 'nearest'
    });
    
    // Добавляем дополнительный отступ после прокрутки
    setTimeout(() => {
      window.scrollBy({
        top: -100,
        behavior: 'smooth'
      });
    }, 100);
  };

  useEffect(() => {
    // IMPORTANT: The image names here MUST match the files you export from Figma
    const mockCases = [
      { 
        _id: '1', 
        name: 'Light Case', 
        price: 50, 
        image: 'light-case-card.png',
        mainPrizes: [
          { name: '', price: 360, image: 'prize-cake.png' },
          { name: '', price: 300, image: 'prize-lollipop.png' },
        ],
        potentialPrizes: [
          { name: '', price: 360, image: 'prize-cake.png', chance: 5 },
          { name: '', price: 300, image: 'prize-lollipop.png', chance: 15 },
          // ... add other small prizes for this case
        ]
      },
      { 
        _id: '2', 
        name: 'Medium Case', 
        price: 120, 
        image: 'medium-case-card.png',
        mainPrizes: [
          { name: '', price: 540, image: 'prize-mimic.png' },
          { name: '', price: 830, image: 'prize-jele.png' },
          { name: '', price: 900, image: 'prize-egg.png' },
        ],
        potentialPrizes: [
          { name: '', price: 540, image: 'prize-mimic.png', chance: 5 },
          { name: '', price: 830, image: 'prize-jele.png', chance: 5 },
          { name: '', price: 900, image: 'prize-egg.png', chance: 5 },
          // ... add other small prizes for this case
        ]
      },
      { _id: '3', name: 'Boss Case', price: 150, image: 'boss-case-card.png' },
      { _id: '4', name: 'Powered Case', price: 349, image: 'powered-case-card.png',
        mainPrizes: [
          { name: '', price: 2300, image: 'prize-hat.png' },
          { name: '', price: 7630, image: 'prize-hemlet.png' },
          { name: '', price: 3160, image: 'prize-rose.png' },
          { name: '', price: 2230, image: 'prize-bottle.png' }
        ],
        potentialPrizes: [
          { name: '', price: 2300, image: 'prize-hat.png', chance: 5 },
          { name: '', price: 7630, image: 'prize-hemlet.png', chance: 5 },
          { name: '', price: 3160, image: 'prize-rose.png', chance: 5 },
          { name: '', price: 2230, image: 'prize-bottle.png', chance: 5 },
          // ... add other small prizes for this case
        ]
      },
      { _id: '5', name: 'Time Pepe Case', price: 599, image: 'pepe-case-card.png',
        mainPrizes: [
          { name: '', price: 910800, image: 'prize-pepe.png' },
          { name: '', price: 9014, image: 'prize-frog.png' }
        ],
        potentialPrizes: [
          { name: '', price: 910800, image: 'prize-pepe.png', chance: 5 },
          { name: '', price: 9014, image: 'prize-frog.png', chance: 5 },
          // ... add other small prizes for this case
        ]
      },
      { _id: '6', name: 'Free Case', price: 0, image: 'free-case-card.png',
        mainPrizes: [
          { name: '', price: 1000, image: 'prize-stars-symbol.png' },
          { name: '', price: 500, image: 'prize-stars-symbol.png' }
        ],
        potentialPrizes: [
          { name: '', price: 100, image: 'prize-stars-symbol.png' },
          { name: '', price: 50, image: 'prize-stars-symbol.png' },
          { name: '', price: 10, image: 'prize-stars-symbol.png' },
          { name: '', price: 1, image: 'prize-stars-symbol.png' }
        ]
      },
    ];

    // Добавляем стоимость в TON для каждого кейса
    const casesWithTonPrice = mockCases.map(caseItem => ({
      ...caseItem,
      tonPrice: caseItem.price > 0 ? (caseItem.price / TON_TO_STARS_RATE).toFixed(2) : 0
    }));

    setCases(casesWithTonPrice);
    setLoading(false);
    
    // The setError is kept for the actual API call logic
    if(error) setError(null);


    // TODO: Replace with actual API call
    /*
    fetch('/api/gifts')
      .then(res => {
        if (!res.ok) throw new Error('Ошибка загрузки кейсов');
        return res.json();
      })
      .then(data => {
        setCases(data);
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
    */
  }, [error]);

  // Функция для открытия free case
  const handleOpenFreeCase = () => {
    const freeCase = cases.find(c => c.name === 'Free Case' || c._id === '6');
    if (freeCase) setOpenCase(freeCase);
  };
  const handleCloseCase = () => setOpenCase(null);

  // Функция для передачи в Case, чтобы начислять звёзды
  const handleAddStars = (amount) => {
    if (typeof onAddStars === 'function') {
      onAddStars(amount);
    }
  };

  if (loading) return <div className="loading-message">Загрузка кейсов...</div>;
  if (error) return <div className="error-message">Ошибка: {error}</div>;

  return (
    <div className="cases-page-container">
      <HomeHero 
        onOpenBalanceModal={onOpenBalanceModal} 
        onScrollToCases={scrollToCases}
        onOpenFreeCase={handleOpenFreeCase}
      />
      <LiveFeed />
      <div ref={casesRef}>
        <h1 className="cases-page-title">Кейсы</h1>
        <div className="case-list-nova">
          {cases.map((caseItem) => (
            <Case 
              key={caseItem._id} 
              caseItem={caseItem}
              balance={balance}
              onOpenBalanceModal={onOpenBalanceModal}
              onAddStars={handleAddStars}
            />
        ))}
        </div>
      </div>
      {openCase && (
        <div className="modal-overlay" onClick={handleCloseCase}>
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="modal-close-btn" onClick={handleCloseCase}>&times;</button>
            <CaseDetail 
              caseItem={openCase} 
              onClose={handleCloseCase}
              balance={balance}
              onOpenBalanceModal={onOpenBalanceModal}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CaseList; 